import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    allTUByCode: {},
    country : '',
    countryID: '',
    countryInfo: {},
    year: 0,
    years: '',
    territorial_level : '',
    territorial_unit : '',
    indicators: null,
    indicatorsFUA: null,
    indicatorsEFUA: null,
    indicatorsCY: null,
    indicator : '',
    indicatorURL : '',
    indicatorVar : '',
    indicatorUnit: '',
    indicatorTitle: '',
    indicatorObj: {},
    indicatorsForCode: {},
    region_city : '',
    map : '',
    oecd : '',
    zoom : '',
    
    default_country : '',
    default_territorial_level : '',
    default_territorial_level_R : '',
    default_territorial_level_C : '',
    default_territorial_unit : '',
    default_indicator : '',
    default_indicatorURL : '',
    default_indicatorObj : '',
    countries: [],
    countries_polygon: [],
    TL3: [],
    TL2: [],
    FUA: [],
    EFUA: [],
    CY: [],
    TableFUACities: {},
    current_polygons: null,
    current_polygonsNorthAmerica: null,
    current_polygonsEurope: null,
    tl3_polygon: null,
    tl2_polygon: null,
    fua_polygon: null,
    efua_polygon: null,
    efua_polygons: null,
    cy_polygon: null,
    cy_polygons: null,
    fuas_polygon: null,
    TU_polygon: null,
    TU_geometry: null,
    polygon_layer: null,
    OSM_layer: null,
    ds: '',
    territorial_levels_R: [],
    territorial_levels_C: [],

    keyTL3: '',
    keyTL2: '',
    keyCountry: '',
    desTL3: '',
    desTL2: '',
    coordinatesTL2: '',
    desCountry: '',
    click: '',
    show_overlay: '',
    legendColors: [],
    legendColorsDefault: [],
    NorthAmericaProjection: '',
    EuropeProjection: '',
    legendThresholds: [],
    countryElements: null,
    // population: null,
    FUASpopulation: null,
    lastStoreData: '',
    objTL2: [],
    objTL3: [],
    objEFUA: [],
    objCY: [],
    objFUA: [],
    movemap: {}
  },
  getters: {
    all:state => state,
    allTUByCode: state => state.allTUByCode,
    lastStoreData:state => state.lastStoreData,
    country:state => state.country,
    countryID:state => state.countryID,
    countryInfo:state => state.countryInfo,
    // population:state => state.population,
    year:state => state.year,
    years:state => state.years,
    TL:state => state.territorial_level,
    TU:state => state.territorial_unit,
    indicators: state => state.indicators,
    indicatorsFUA: state => state.indicatorsFUA,
    indicatorsEFUA: state => state.indicatorsEFUA,
    indicatorsCY: state => state.indicatorsCY,
    indicator:state => state.indicator,
    indicatorURL:state => state.indicatorURL,
    indicatorVar:state => state.indicatorVar,
    indicatorUnit:state => state.indicatorUnit,
    indicatorTitle:state => state.indicatorTitle,
    indicatorObj:state => state.indicatorObj,
    indicatorsForCode: state => state.indicatorsForCode,
    default_country:state => state.default_country,
    default_TL:state => state.default_territorial_level,
    default_TL_R:state => state.default_territorial_level_R,
    default_TL_C:state => state.default_territorial_level_C,
    default_TU:state => state.default_territorial_unit,
    default_indicator:state => state.default_indicator,
    default_indicatorURL:state => state.default_indicatorURL,
    default_indicatorObj:state => state.default_indicatorObj,
    R_C:state => state.region_city,
    legendColors:state => state.legendColors,
    legendColorsDefault:state => state.legendColorsDefault,
    NorthAmericaProjection:state => state.NorthAmericaProjection,
    EuropeProjection:state => state.EuropeProjection,
    legendThresholds: state => state.legendThresholds,
    map:state => state.map,
    oecd:state => state.oecd,
    zoom:state => state.zoom,
    countries:state => state.countries,
    countries_polygon:state => state.countries_polygon,
    countryElements: state => state.countryElements,
    TL3:state => state.TL3,
    getTL3ByName: (state) => (name) => {
      return state.TL3.find(tu => tu.name === name)
    },    
    getTL3ByCode: (state) => (code) => {
      return state.TL3.find(tu => tu.code === code)
    },
    TL2:state => state.TL2,
    FUA:state => state.FUA,
    EFUA:state => state.EFUA,
    CY:state => state.CY,
    TableFUACities:state => state.TableFUACities,
    FUASpopulation: state => state.FUASpopulation,
    getFUAByCode: (state) => (code) => {
      return state.FUA.find(tu => tu.id === code)
    },
    getEFUAByCode: (state) => (code) => {
      return state.EFUA.find(tu => tu.id === code)
    },                
    getCYByCode: (state) => (code) => {
      return state.CY.find(tu => tu.id === code)
    },                
    getTL2ByName: (state) => (name) => {
      return state.TL2.find(tu => tu.name === name)
    },
    getTL2ByCode: (state) => (code) => {
      return state.TL2.find(tu => tu.code === code)
    },
    current_polygons:state => state.current_polygons,
    current_polygonsNorthAmerica:state => state.current_polygonsNorthAmerica,
    current_polygonsEurope:state => state.current_polygonsEurope,
    tl3_polygon:state => state.tl3_polygon,
    tl2_polygon:state => state.tl2_polygon,
    fuas_polygon:state => state.fuas_polygon,
    fua_polygon:state => state.fua_polygon,
    efua_polygon:state => state.efua_polygon,
    efua_polygons:state => state.efua_polygons,
    cy_polygon:state => state.cy_polygon,
    cy_polygons:state => state.cy_polygons,
    TU_polygon:state => state.TU_polygon,
    TU_geometry:state => state.TU_geometry,
    polygon_layer:state => state.polygon_layer,
    OSM_layer:state => state.OSM_layer,
    ds:state => state.ds,
    territorial_levels_R:state => state.territorial_levels_R,
    territorial_levels_C:state => state.territorial_levels_C,
    getCountryById: (state) => (id) => {
      return state.countries.find(country => country.id === id)
    },
    getCountryByName: (state) => (name) => {
      return state.countries.find(country => country.name === name)
    },
    keyTL3:state => state.keyTL3,
    keyTL2:state => state.keyTL2,
    keyCountry:state => state.keyCountry,

    desTL3:state => state.desTL3,
    desTL2:state => state.desTL2,
    coordinatesTL2:state => state.coordinatesTL2,
    desCountry:state => state.desCountry,
    click:state => state.click,
    show_overlay:state => state.show_overlay,

    objTL2:state => state.objTL2,
    objTL3:state => state.objTL3,
    objEFUA:state => state.objEFUA,
    objCY:state => state.objCY,
    objFUA:state => state.objFUA,
    movemap: state => state.movemap
  },
  mutations: {
    delAllPolygons: (state) => {
      console.log('*** delAllPolygons ***')
      if (state.current_polygons) {
        state.current_polygons = null
        // state.current_polygons.destroy()        
      }
    },
    setAllTUByCode: (state, id) => {
      state.allTUByCode = id
    },
    set_current_polygons:(state, id) => {
      state.current_polygons = id
    },
    set_current_polygonsNorthAmerica:(state, id) => {
      state.current_polygonsNorthAmerica = id
    },
    set_current_polygonsEurope:(state, id) => {
      state.current_polygonsEurope = id
    },        
    setLastStoreData: (state, id) => {
      state.lastStoreData = id
    },
    setCountry: (state, id) => {
      state.country = id
    },
    setCountryElements: (state, id) => {
      state.countryElements = id
    },
    /*
    setPopulation: (state, id) => {
      state.population = id
    },
    */
    setLegendThresholds: (state, id) => {
      state.legendThresholds = id
    },
    setLegendColors: (state, id) => {
      state.legendColors = id
    },
    setNorthAmericaProjection: (state, id) => {
      state.NorthAmericaProjection = id
    },
    setEuropeProjection: (state, id) => {
      state.EuropeProjection = id
    },
    setLegendColorsDefault: (state, id) => {
      state.legendColorsDefault = id
    },
    setCountryID: (state, id) => {
      state.countryID = id
    },
    setCountryInfo: (state, id) => {
      state.countryInfo = id
    },
    setYear: (state, id) => {
      state.year = id
    },
    setYears: (state, id) => {
      state.years = id
    },    
    setTL: (state, id) => {
      state.territorial_level = id
    },
    setTU: (state, id) => {
      state.territorial_unit = id
    },
    setIndicators: (state, id) => {
      state.indicators = id
    },
    setIndicatorsFUA: (state, id) => {
      state.indicatorsFUA = id
    },
    setIndicatorsEFUA: (state, id) => {
      state.indicatorsEFUA = id
    },
    setIndicatorsCY: (state, id) => {
      state.indicatorsCY = id
    },
    setIndicator: (state, id) => {
      state.indicator = id
    },
    setIndicatorVar: (state, id) => {
      state.indicatorVar = id
    },
    setIndicatorUnit: (state, id) => {
      state.indicatorUnit = id
    },
    setIndicatorTitle: (state, id) => {
      state.indicatorTitle = id
    },    
    setIndicatorURL: (state, id) => {
      state.indicatorURL = id
    },    
    setIndicatorObj: (state, id) => {
      state.indicatorObj = id
    },
    setIndicatorsForCode: (state, id) => {
      state.indicatorsForCode = id
    },
    setR_C: (state, id) => {
      state.region_city = id
    },
    setMap: (state, id) => {
      state.map = id
    },
    setOecd: (state, id) => {
      state.oecd = id
    },        
    setZoom: (state, id) => {
      state.zoom = id
    },
    setCountries: (state, countries) => {
      state.countries = countries
    },
    setcountries_polygon: (state, countries_polygon) => {
      state.countries_polygon = countries_polygon
    },    
    setTL3: (state, TL3) => {
      state.TL3 = TL3
    },
    setTL2: (state, TL2) => {
      state.TL2 = TL2
    },
    setEFUA: (state, EFUA) => {
      state.EFUA = EFUA
    },    
    setCY: (state, CY) => {
      state.CY = CY
    },    
    setFUA: (state, FUA) => {
      state.FUA = FUA
    },    
    setTableFUACities: (state, TableFUACities) => {
      state.TableFUACities = TableFUACities
    },    
    setFUASpopulation: (state, FUASpopulation) => {
      state.FUASpopulation = FUASpopulation
    },    
    settl3_polygon: (state, tl3_polygon) => {
      state.tl3_polygon = tl3_polygon
    },
    settl2_polygon: (state, tl2_polygon) => {
      state.tl2_polygon = tl2_polygon
    },    
    setfuas_polygon: (state, fuas_polygon) => {
      state.fuas_polygon = fuas_polygon
    },        
    setfua_polygon: (state, fua_polygon) => {
      state.fua_polygon = fua_polygon
    },    
    setefua_polygon: (state, efua_polygon) => {
      state.efua_polygon = efua_polygon
    },    
    setefua_polygons: (state, efua_polygons) => {
      state.efua_polygons = efua_polygons
    },    
    setcy_polygon: (state, cy_polygon) => {
      state.cy_polygon = cy_polygon
    },    
    setcy_polygons: (state, cy_polygons) => {
      state.cy_polygons = cy_polygons
    },    
    setTU_polygon: (state, TU_polygon) => {
      state.TU_polygon = TU_polygon
    },     
    setTU_geometry: (state, TU_geometry) => {
      state.TU_geometry = TU_geometry
    },
    setpolygon_layer: (state, polygon_layer) => {
      state.polygon_layer = polygon_layer
    },
    setOSM_layer: (state, OSM_layer) => {
      state.OSM_layer = OSM_layer
    },    
    setds: (state, ds) => {
      if (state.ds) {
        state.ds = null
      }
      state.ds = ds
    },        
    setTerritorial_levels_R: (state, territorial_levels_R) => {
      state.territorial_levels_R = territorial_levels_R
    },
    setTerritorial_levels_C: (state, territorial_levels_C) => {
      state.territorial_levels_C = territorial_levels_C
    },
    setobjTL2: (state, objTL2) => {
      state.objTL2 = objTL2
    },
    setobjTL3: (state, objTL3) => {
      state.objTL3 = objTL3
    },
    setobjEFUA: (state, objEFUA) => {
      state.objEFUA = objEFUA
    },
    setobjCY: (state, objCY) => {
      state.objCY = objCY
    },
    setobjFUA: (state, objFUA) => {
      state.objFUA = objFUA
    },
    setDefaultValue: (state, defaultValues) => {
      state.default_country = defaultValues['country']
      state.default_territorial_level = defaultValues['territorial_level_R']
      state.default_territorial_level_R = defaultValues['territorial_level_R']
      state.default_territorial_level_C = defaultValues['territorial_level_C']
      state.default_indicator = defaultValues['indicator']
      state.default_indicatorURL = defaultValues['indicatorURL']
      //state.default_indicatorUnit = defaultValues['indicatorUnit']
      state.default_territorial_unit = defaultValues['territorial_unit']
      state.default_indicatorObj = defaultValues['indicatorObj']

      state.zoom = ''
      state.year = 2019
      state.country = state.default_country
      state.countryID = state.default_country  
      state.territorial_level = state.default_territorial_level
      state.indicator = state.default_indicator
      state.indicatorURL = state.default_indicatorURL
      //state.indicatorUnit = state.default_indicatorUnit
      
      state.territorial_unit = state.default_territorial_unit
      state.region_city = 'R'
      state.map = true
      state.oecd = false
    },
    restoreDefaultValue: (state) => {
      state.zoom = ''
      state.country = state.default_country
      state.countryID = state.default_country
      state.territorial_level = state.default_territorial_level
      state.indicator = state.default_indicator
      state.indicatorURL = state.default_indicatorURL
      state.indicatorObj = state.default_indicatorObj
      state.territorial_unit = state.default_territorial_unit
      state.region_city = 'R'
      state.map = true
      state.oecd = false
    },
    setkeyTL3: (state, id) => {
      state.keyTL3 = id
    },    
    setkeyTL2: (state, id) => {
      state.keyTL2 = id
    },    
    setkeyCountry: (state, id) => {
      state.keyCountry = id
    },
    setdesTL3: (state, id) => {
      state.desTL3 = id
    },    
    setdesTL2: (state, id) => {
      state.desTL2 = id
    },    
    setcoordinatesTL2: (state, id) => {
      state.coordinatesTL2 = id
    },        
    setdesCountry: (state, id) => {
      state.desCountry = id
    },
    setclick: (state, id) => {
      state.click = id
    },
    setshow_overlay: (state, id) => {
      state.show_overlay = id
    },
    setMoveMap: (state, id) => {
      state.movemap[id.map] = id.coord
    }
  },
  actions: {
    setAllTUByCode: (context, id) => {
      context.commit('setAllTUByCode', id)
    },
    setLastStoreData: (context, id) => {
      context.commit('setLastStoreData', id)
    },
    setCountry: (context, id) => {
      context.commit('setCountry', id)
    },
    setCountryElements: (context, id) => {
      context.commit('setCountryElements', id)
    },
    /*
    setPopulation: (context, id) => {
      context.commit('setPopulation', id)
    },
    */
    setCountryID: (context, id) => {
      context.commit('setCountryID', id)
    },
    setCountryInfo: (context, id) => {
      context.commit('setCountryInfo', id)
    },
    setLegendColors: (context, id) => {
      context.commit('setLegendColors', id)
    },
    setNorthAmericaProjection: (context, id) => {
      context.commit('setNorthAmericaProjection', id)
    },
    setEuropeProjection: (context, id) => {
      context.commit('setEuropeProjection', id)      
    },
    setLegendColorsDefault: (context, id) => {
      context.commit('setLegendColorsDefault', id)
    },
    setLegendThresholds: (context, id) => {
      context.commit('setLegendThresholds', id)
    },
    setYear: (context, id) => {
      context.commit('setYear', id)
    },
    setYears: (context, id) => {
      context.commit('setYears', id)
    },    
    setTL: (context, id) => {
      context.commit('setTL', id)
    },
    setTU: (context, id) => {
      context.commit('setTU', id)
    },
    setIndicators: (context, id) => {
      context.commit('setIndicators', id)
    },
    setIndicatorsFUA: (context, id) => {
      context.commit('setIndicatorsFUA', id)
    },
    setIndicatorsEFUA: (context, id) => {
      context.commit('setIndicatorsEFUA', id)
    },
    setIndicatorsCY: (context, id) => {
      context.commit('setIndicatorsCY', id)
    },
    setIndicator: (context, id) => {
      context.commit('setIndicator', id)
    },
    setIndicatorVar: (context, id) => {
      context.commit('setIndicatorVar', id)
    },
    setIndicatorURL: (context, id) => {
      context.commit('setIndicatorURL', id)
    },    
    setIndicatorUnit: (context, id) => {
      context.commit('setIndicatorUnit', id)
    },
    setIndicatorTitle: (context, id) => {
      context.commit('setIndicatorTitle', id)
    },        
    setIndicatorObj: (context, id) => {
      context.commit('setIndicatorObj', id)
    },
    setIndicatorsForCode: (context, id) => {
      context.commit('setIndicatorsForCode', id)
    },
    setR_C: (context, id) => {
      context.commit('setR_C', id)
    },
    setMap: (context, id) => {
      context.commit('setMap', id)
    },    
    setOecd: (context, id) => {
      context.commit('setOecd', id)
    },        
    setZoom: (context, id) => {
      context.commit('setZoom', id)
    },
    setCountries: (context, countries) => {
      context.commit('setCountries', countries)
    },
    setcountries_polygon: (context, countries_polygon) => {
      context.commit('setcountries_polygon', countries_polygon)
    },    
    setTL3: (context, TL3) => {
      context.commit('setTL3', TL3)
    },    
    setTL2: (context, TL2) => {
      context.commit('setTL2', TL2)
    },
    setFUA: (context, FUA) => {
      context.commit('setFUA', FUA)
    },  
    setTableFUACities: (context, TableFUACities) => {
      context.commit('setTableFUACities', TableFUACities)
    },  
    

    setEFUA: (context, EFUA) => {
      context.commit('setEFUA', EFUA)
    },
    setCY: (context, CY) => {
      context.commit('setCY', CY)
    },

    setobjTL2: (context, objTL2) => {
      context.commit('setobjTL2', objTL2)
    },
    setobjTL3: (context, objTL3) => {
      context.commit('setobjTL3', objTL3)
    },
    setobjEFUA: (context, objEFUA) => {
      context.commit('setobjEFUA', objEFUA)
    },
    setobjCY: (context, objCY) => {
      context.commit('setobjCY', objCY)
    },
    setobjFUA: (context, objFUA) => {
      context.commit('setobjFUA', objFUA)
    },
    setFUASpopulation: (context, FUASpopulation) => {
      context.commit('setFUASpopulation', FUASpopulation)
    },    
    settl3_polygon: (context, tl3_polygon) => {
      context.commit('settl3_polygon', tl3_polygon)
    },
    settl2_polygon: (context, tl2_polygon) => {
      context.commit('settl2_polygon', tl2_polygon)
    },
    setefua_polygons: (context, efua_polygons) => {
      context.commit('setefua_polygons', efua_polygons)
    },    
    setfuas_polygon: (context, fuas_polygon) => {
      context.commit('setfuas_polygon', fuas_polygon)
    },    
    setfua_polygon: (context, fua_polygon) => {
      context.commit('setfua_polygon', fua_polygon)
    },    
    setefua_polygon: (context, efua_polygon) => {
      context.commit('setefua_polygon', efua_polygon)
    },   

    setcy_polygons: (context, cy_polygons) => {
      context.commit('setcy_polygons', cy_polygons)
    },    
    setcy_polygon: (context, cy_polygon) => {
      context.commit('setcy_polygon', cy_polygon)
    },   
 
    setTU_polygon: (context, TU_polygon) => {
      context.commit('setTU_polygon', TU_polygon)
    },
    setTU_geometry: (context, TU_geometry) => {
      context.commit('setTU_geometry', TU_geometry)
    },
    setpolygon_layer: (context, polygon_layer) => {
      context.commit('setpolygon_layer', polygon_layer)
    },
    setOSM_layer: (context, OSM_layer) => {
      context.commit('setOSM_layer', OSM_layer)
    },    
    setds: (context, ds) => {
      context.commit('setds', ds)
    },        
    setTerritorial_levels_R: (context, territorial_levels_R) => {
      context.commit('setTerritorial_levels_R', territorial_levels_R)
    },    
    setTerritorial_levels_C: (context, territorial_levels_C) => {
      context.commit('setTerritorial_levels_C', territorial_levels_C)
    },    
    setDefaultValue: (context, defaultValues) => {
      context.commit('setDefaultValue', defaultValues)
    },
    restoreDefaultValue: (context) => {
      context.commit('restoreDefaultValue')
    },
    setkeyTL3: (context, id) => {
      context.commit('setkeyTL3', id)
    },    
    setkeyTL2: (context, id) => {
      context.commit('setkeyTL2', id)
    },    
    setkeyCountry: (context, id) => {
      context.commit('setkeyCountry', id)
    },
    setdesTL3: (context, id) => {
      context.commit('setdesTL3', id)
    },    
    setdesTL2: (context, id) => {
      context.commit('setdesTL2', id)
    },    
    setcoordinatesTL2: (context, id) => {
      context.commit('setcoordinatesTL2', id)
    },        
    setdesCountry: (context, id) => {
      context.commit('setdesCountry', id)
    },
    setclick: (context, id) => {
      context.commit('setclick', id)
    },
    setshow_overlay: (context, id) => {
      context.commit('setshow_overlay', id)
    },
    setMoveMap: (context, id) => {
      context.commit('setMoveMap', id)
    }
  },
  modules: {
  }
})
